/**
 * The only three things anyone touches on the wall.
 *
 * The handoff wrote these for a remote trigger — a phone action or a physical
 * button — but the panel is a touchscreen, so they are real targets. At 21px
 * text with 14px of padding each is comfortably past 44px tall, which is what
 * saves them from needing to be redrawn for fingers.
 */
export function KitchenControls({
  view,
  onView,
  onPrevMonth,
  onNextMonth,
  onThisMonth,
  atThisMonth,
}: {
  view: "week" | "month";
  onView: (view: "week" | "month") => void;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onThisMonth: () => void;
  /** Whether the grid is already showing the month today is in. */
  atThisMonth: boolean;
}): React.JSX.Element {
  return (
    <div className="kd-controls">
      {/* Month navigation belongs to the month. In the week view there is
          nothing to page — the week is always this week. */}
      {view === "month" && (
        <div className="kd-nav">
          <button type="button" className="kd-nav__arrow" aria-label="Previous month" onClick={onPrevMonth}>
            ←
          </button>
          <button
            type="button"
            className={`kd-nav__today${atThisMonth ? " is-there" : ""}`}
            onClick={onThisMonth}
          >
            Today
          </button>
          <button type="button" className="kd-nav__arrow" aria-label="Next month" onClick={onNextMonth}>
            →
          </button>
        </div>
      )}

      <div className="kd-toggle">
        <button
          type="button"
          className={`kd-toggle__option${view === "week" ? " is-on" : ""}`}
          aria-pressed={view === "week"}
          onClick={() => onView("week")}
        >
          Week
        </button>
        <button
          type="button"
          className={`kd-toggle__option${view === "month" ? " is-on" : ""}`}
          aria-pressed={view === "month"}
          onClick={() => onView("month")}
        >
          Month
        </button>
      </div>
    </div>
  );
}
